import React from 'react';
import { RouteArrowDisplay } from '../../../app/RouteArrowDisplay/RouteArrowDisplay';
import { RefDisplay } from '../../../app/Ref/RefDisplay';

export interface OrderDrawerHeaderProps {
  pickupCity?: string;
  dropoffCity?: string;
  refMain?: string;
  refShort?: string;
  /**
   * A second reference line under Hero's own ref — today the Logisti / Bayan
   * trip id (`<GovernmentWaybillRef />`).
   *
   * A slot rather than an `order` prop: this header takes primitives, and
   * reaching for the whole order just to read one optional sub-document would
   * make every consumer pass one.
   */
  secondaryRef?: React.ReactNode;
}

export const OrderDrawerHeader: React.FC<OrderDrawerHeaderProps> = ({
  pickupCity,
  dropoffCity,
  refMain,
  refShort,
  secondaryRef,
}) => {
  return (
    <div className="flex items-start justify-between pb-4 mb-3 border-b">
      <h1 className="flex items-center gap-1 h6 text-dark">
        <RouteArrowDisplay
          origin={{ city: { name: pickupCity ?? '' } }}
          destinations={[{ city: { name: dropoffCity ?? '' } }]}
          size="large"
        />
      </h1>
      <div className="flex min-w-0 flex-col items-end gap-0.5">
        <RefDisplay refMain={refMain} refShort={refShort} />
        {secondaryRef}
      </div>
    </div>
  );
};
